export const SHOP_PAGE_SIZE = 24;
export const MAX_REPOP_RECEIPTS = 4;
export const MAX_BATCH_SHOP_USERNAMES = 10;
export const SHOP_DROP_POST_LAUNCH_SIGNUP_QUERY_PARAMS = {
  key: 'from',
  value: 'signup_cta',
};
